import api from "./api";
import {API_PROJECT_TYPE} from "../constants/urls";

/**
 * Servicio cargar tipo de super-servicio
 */

export const projectType = {
    getProjectType: async () => (await api.get(API_PROJECT_TYPE)).data
};

